export const actionTypes = {
  LOGIN: "LOGIN",
  REGISTER: "REGISTER",
  LOGOUT: "LOGOUT",
  UPDATE_ME: "UPDATE_ME",
};

export const initialState = { me: undefined };
